import React from 'react';
import { modes } from '@comall-backend-builder/types';
import { RichText } from '@comall-backend-builder/components-richtext';

const DEFAULT_UPLOAD_CONFIG = {
    apiPath: '/images',
    fileName: 'fileName',
    progressCallBack: () => undefined,
};

/**
 * 商品移动端详情等场景的富文本控件
 * 与批量配置表单一致：onChange 仅传 html，避免 antd Form 同步异常
 */
export class StringRichTextPZGMode extends modes.StringRichTextMode {
    getControlComponent(controlInfo: any) {
        const { value, onChange, placeholder, uploadConfig, ...rest } = controlInfo;

        return (
            <RichText
                {...rest}
                name={controlInfo.name}
                value={value || ''}
                placeholder={placeholder}
                uploadConfig={uploadConfig || DEFAULT_UPLOAD_CONFIG}
                onChange={(html: string) => {
                    if (onChange) {
                        onChange(html);
                    }
                }}
            />
        );
    }

    getAvailableDisplayComponent(value: any, displayInfo: any) {
        const controlInfo = {
            ...displayInfo,
            disabled: true,
            value,
        };
        return this.getControlComponent(controlInfo);
    }
}
